export const Constant = {
BASE_URL: "https://clo-api.cheggout.com/api/v1.0", //Production
//BASE_URL: "https://cloapi-stage.cheggout.com/api/v1.0", //Stage
TOKEN: "https://pwarewardsapi-stage-a2ftgfbkbqezfyhp.centralindia-01.azurewebsites.net/api/v3", //Get token with cust_id
 CAMPAIGN_URL: "https://apiuser-cheggout-rewards.snowtint.com/api/v2",
 COUPON_URL: "https://restapi-stage.cheggout.com//api/v1.3",
  TOKEN_GENERATION: "GetToKenForPWA",
  TOKEN_VALIDATION: "ValidateToken",
  GET_DINING_CITY: "GetDineInCity",
  GET_DINING_LOCATION: "GetDineInLocation",
  GET_RESTAURANTS_CATEGORY: "GetRestaurantsType",
  GET_DINEIN_OUTLETS: "GetDineInOutlets",
  GET_WALLET_POINTS: "GetPWAWalletPoints",
  GET_COUPONS: "GetCoupons",
  DINE_IN_PAYMENT: "ValidateDineInPayment",
  PAYMENT_STATUS: "GetDineInPaymentStatus",
  PAYMENT_SUMMARY: "DineBookingInfo",
  GET_DINEIN_OUTLET_DETAIL: "GetDineInOutletDetails",
  GET_QUERIES: "GetUserJiraTikets",
  POST_QUERIES: "CreatIssueInJiraServiceWithAttachment",
  CREATE_REVIEWS: "InsertReviews",
  GET_DINEBOOK_INFO:"DineBookingInfo",
  GET_DINEIN_OUTLET_BYNAME:"GetDineInOutletbyName",
  GET_BEST_OFFER:"GetBestOffer",
  GET_CAROUSEL_IMG:"GetDineInBanner",
  GET_CITY_LOCATION:"GetDineCityInLocation",
  USER_TRACTION:"InsertDineInActivity",
  CAMPAIGN_INFO:"CreateScratchCard",
  REWARDS_VALIDATION:"ValidateToken",
  GET_CAMPAIGN_REWARD_TYPE:"GetCampaignDetails",
  CHECK_COUPON_CODE_EXIST:"CheckPromotionCodeExist",
  GET_TOKEN:"GetTokenForPWA"
};

export const statusCode = {
  errorCode: 500,
  successCode: 200,
};

export const updateHeaders = (passedToken) => {
  Headers.Authorization = `Bearer ${passedToken}`;
  CAMPAIGN_HEADERS.Authorization = `Bearer ${passedToken}`;
};

const token = sessionStorage.getItem("token");

export const Headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + token,
  applicationId: "pwa1",
};

export const CAMPAIGN_HEADERS = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + token
}

export const SimpleHeaders = {
  "Content-Type": "application/json"
};

